var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.groupedTags, function(tags, tagType) {
      return _c(
        "div",
        { key: tagType, staticClass: "timeline__item-container" },
        [
          _c(
            "div",
            {
              staticClass:
                "timeline__item timeline__item--hide-timeline flex--grow"
            },
            [
              _c("i", { staticClass: "fa fa-tag m-t-2 f-s-10" }),
              _vm._v(" "),
              _c("div", { staticClass: "flex--grow" }, [
                _c("div", { staticClass: "m-l-7 m-b-3" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm._f("camelCaseFormat")(tagType)))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "m-l-7" },
                  _vm._l(tags, function(tag, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "generic-args" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "generic-args__name overflow-ellipsis"
                          },
                          [
                            _c(
                              "TruncatedTextCopy",
                              {
                                attrs: {
                                  "copy-text": _vm._f("camelCaseFormat")(
                                    tag.name
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("camelCaseFormat")(tag.name)
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "generic-args__value overflow-ellipsis"
                          },
                          [
                            _c(
                              "TruncatedTextCopy",
                              { attrs: { "copy-text": tag.value } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(tag.value) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }